// extracted by mini-css-extract-plugin
export default {"table-layout":"CompanyTable_table-layout__LswRp","icon-3-dots":"CompanyTable_icon-3-dots__6bH9N"};